import {
  defaultOrganisation,
  testOrganisationResourcesDisabled,
} from "./organisation";
import {
  GetOrganisationDocument,
  GetOrganisationQuery,
  GetOrganisationQueryVariables,
} from "../GeneratedGraphQL";

import { defaultService } from "./service";
import { MockedResponse } from "@apollo/client/testing";
import { multipleServices } from "./service";

const organisation = {
  ...defaultOrganisation,
  services: {
    edges: [{ cursor: defaultService._id, node: defaultService }],
    pageInfo: {
      endCursor: null,
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: null,
      total: 1,
    },
  },
};

const organisationResourcesDisabled = {
  ...testOrganisationResourcesDisabled,
  services: {
    edges: [{ cursor: defaultService._id, node: defaultService }],
    pageInfo: {
      endCursor: defaultService._id,
      hasNextPage: false,
      hasPreviousPage: false,
      startCursor: defaultService._id,
      total: 1,
    },
  },
};

export const defaultOrganisationRequest: MockedResponse<GetOrganisationQuery> =
  {
    request: {
      query: GetOrganisationDocument,
      variables: { id: defaultOrganisation._id },
    },
    result: { data: { organisation: organisation } },
  };

export const genericMultiPageServicesOrganisationRequests: MockedResponse<GetOrganisationQuery>[] =
  multipleServices.map((service, i) => {
    const variables: GetOrganisationQueryVariables = {
      id: defaultOrganisation._id,
    };
    if (i !== 0) {
      variables.serviceCursor = multipleServices[i - 1]._id;
    }

    return {
      request: { query: GetOrganisationDocument, variables },
      result: {
        data: {
          organisation: {
            ...organisation,
            services: {
              edges: [{ cursor: service._id, node: service }],
              /* eslint-disable sort-keys */
              pageInfo: {
                hasPreviousPage: false,
                hasNextPage: true,
                total: multipleServices.length,
                startCursor: service._id,
                endCursor: service._id,
              },
              /* eslint-enable sort-keys */
            },
          },
        },
      },
    };
  });

export const organisationForceTimezoneRequest: MockedResponse<GetOrganisationQuery> =
  {
    request: {
      query: GetOrganisationDocument,
      variables: { id: testOrganisationResourcesDisabled._id },
    },
    result: {
      data: {
        organisation: {
          ...organisationResourcesDisabled,
          forceTimezone: "Europe/Berlin",
        },
      },
    },
  };
